import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function EmployeesCard() {

const employees = [
{
name:"Anthony Lewis",
role:"Finance",
img:"/assets/img/users/user-32-1.jpg",
badge:"Finance",
color:"#0F4C5C",
bg:"#e7f2f5"
},
{
name:"Brian Villalobos",
role:"PHP Developer",
img:"/assets/img/users/user-09.jpg",
badge:"Development",
color:"#ff3b30",
bg:"#fdecea"
},
{
name:"Stephan Peralt",
role:"Executive",
img:"/assets/img/users/user-01-1.jpg",
badge:"Marketing",
color:"#2f80ed",
bg:"#e8f0ff"
},
{
name:"Doglas Martini",
role:"Project Manager",
img:"/assets/img/users/user-34.jpg",
badge:"Manager",
color:"#9b59b6",
bg:"#f3e9fb"
},
{
name:"Anthony Lewis",
role:"UI/UX Designer",
img:"/assets/img/users/user-37.jpg",
badge:"UI/UX Design",
color:"#ff4d8d",
bg:"#ffe8f1"
}
];

return(
<>
<Card className="employees-card h-100">

<div className="employees-header">
<h6>Employees</h6>
<Link  className="text-decoration-none  "  to="/employee-lists" >
<Button className="view-button border border-1">View All</Button>
</Link>
</div>

<div className="employees-body">

{employees.map((emp,index)=>(
<div
key={index}
className={`emp-card-row ${index===employees.length-1?"emp-last-row":""}`}
>

<div className="emp-left">

<img src={emp.img} className="emp-avatar" alt="employee"/>

<div className="emp-info">
<div className="emp-name">{emp.name}</div>
<div className="emp-role">{emp.role}</div>
</div>

</div>

<span
className="emp-badge"
style={{background:emp.bg,color:emp.color}}
>
{emp.badge}
</span>

</div>
))}

</div>

</Card>

<style>{`

/* CARD */

.employees-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
overflow:hidden;
background:#fff;
margin:0;
}

/* HEADER */

.employees-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #e9ecef;
}

.employees-header h6{
margin:0;
font-size:15px;
font-weight:600;
color:#1f2937;
}

/* BUTTON */

.view-button{
background:#f3f4f6;
border:1px solid #e5e7eb;
font-size:12px;
padding:4px 12px;
border-radius:6px;
color:#374151;
}

/* ROW */

.emp-card-row{
display:flex;
justify-content:space-between;
align-items:center;
padding:13px 15px;
border-bottom:1px solid #f1f3f5;
}

.emp-last-row{
border-bottom:none;
}

/* LEFT */

.emp-left{
display:flex;
align-items:center;
gap:10px;
}

/* AVATAR */

.emp-avatar{
width:36px;
height:36px;
border-radius:50%;
object-fit:cover;
}

/* TEXT */

.emp-name{
font-size:14px;
font-weight:600;
color:#1f2937;
}

.emp-role{
font-size:12px;
color:#6b7280;
margin-top:2px;
}

/* BADGE */

.emp-badge{
padding:4px 8px;
font-size:11px;
border-radius:5px;
font-weight:500;
white-space:nowrap;
}

/* MOBILE */

@media (max-width:768px){

.emp-card-row{
flex-direction:column;
align-items:flex-start;
gap:8px;
}

.emp-badge{
align-self:flex-start;
}

}

`}</style>

</>
);
}